import React, { useState, useCallback, useEffect } from 'react';

import AcceptButtonContent from './accept-button-content';
import EmailSentContent from './email-sent-content';
import ErrorContent from './error-content';
import LoadingContent from './loading-content';
import SigninContent from './signin-content';
import SignupContent from './signup-content';
import SuccessContent from './success-content';

import readInvitationRoute from 'api/routes/invitations/read-invitation';
import Dialog from 'components/content/dialog';

export default function AcceptDialog({ isAuthenticated, id, ...props }) {
  const [state, setState] = useState('loading');
  const [invitation, setInvitation] = useState(null);

  useEffect(() => {
    if (isAuthenticated && ['signin', 'signup'].includes(state)) {
      setState('accept-button');
    }
  }, [state, isAuthenticated]);

  useEffect(() => {
    if (!Number.isInteger(id) || id <= 0) {
      return;
    }
    let isActive = true;
    readInvitationRoute(id).then(({ status, data }) => {
      if (isActive) {
        switch (status) {
          case 200:
            setInvitation(data);
            setState('signup');
            break;
          default:
            setState('error');
        }
      }
    });
    return () => {
      isActive = false;
    };
  }, [id]);

  const handleTransition = useCallback((newState) => {
    setState(newState);
  }, []);

  switch (state) {
    case 'loading':
      return (
        <Dialog fullWidth {...props}>
          <LoadingContent />
        </Dialog>
      );
    case 'error':
      return (
        <Dialog fullWidth {...props}>
          <ErrorContent />
        </Dialog>
      );
    case 'email-sent':
      return (
        <Dialog fullWidth {...props}>
          <EmailSentContent email={invitation.email.address} />
        </Dialog>
      );
    case 'signup':
      return (
        <Dialog fullWidth {...props}>
          <SignupContent
            courseName={invitation.course.code}
            role={invitation.role}
            email={invitation.email.address}
            onTransition={handleTransition}
          />
        </Dialog>
      );
    case 'signin':
      return (
        <Dialog fullWidth {...props}>
          <SigninContent
            courseName={invitation.course.code}
            role={invitation.role}
            email={invitation.email.address}
            onTransition={handleTransition}
          />
        </Dialog>
      );
    case 'accept-button':
      return (
        <Dialog fullWidth {...props}>
          <AcceptButtonContent
            invitationId={id}
            courseName={invitation.course.code}
            role={invitation.role}
            onTransition={handleTransition}
          />
        </Dialog>
      );
    case 'success':
      return (
        <Dialog fullWidth {...props}>
          <SuccessContent
            courseName={invitation.course.code}
            role={invitation.role}
            courseId={invitation.course.id}
          />
        </Dialog>
      );
    default:
      return null;
  }
}
